
export class SeTakebackTransport {
  id: number;
  name: string;
  carrier: string;
  supplementaryEquipments: TakeBackSupplementaryEquipment[] = [];
  identifier: string;
  transportScope: TransportScope;
}

export class TakeBackSupplementaryEquipment {
  equipmentTypeId: string;
  name: string;
  selected: boolean;
  identifier: string;
}

export enum TransportScope {
  SWAP_TRAILER = 'SWAP_TRAILER', TRAILER = 'TRAILER', TRAIN = 'TRAIN', SEMI_TRAILER_TRUCK = 'SEMI_TRAILER_TRUCK'
}

